import URITemplate from 'urijs/src/URITemplate';

export default Object.freeze({

    BACKEND_URL:                    process.env.VUE_APP_BACKEND_URL,

    FORUMS:                         '/api/forums',
    FORUM:                          '/api/forums/{ID_FORUM}',
    FORUM_EVENTS:                   '/api/forums/{ID_FORUM}/events',
    FORUM_EVENT:                    '/api/forums/{ID_FORUM}/events/{ID_EVENT}',
    FORUM_EVENT_SESSIONS:           '/api/forums/{ID_FORUM}/events/{ID_EVENT}/sessions',
    FORUM_EVENT_SESSION:            '/api/forums/{ID_FORUM}/events/{ID_EVENT}/sessions/{ID_SESSION}',

    getForumsUrl() {
        return this.getUrl(this.FORUMS);
    },
    getForumUrl(options) {
        return this.getUrl(this.FORUM, options)
    },
    getForumEventsUrl(options) {
        return this.getUrl(this.FORUM_EVENTS, options);
    },
    getForumEventUrl(options) {
        return this.getUrl(this.FORUM_EVENT, options);
    },
    getForumEventSessionsUrl(options) {
        return this.getUrl(this.FORUM_EVENT_SESSIONS, options);
    },
    getForumEventSessionUrl(options) {
        return this.getUrl(this.FORUM_EVENT_SESSION, options);
    },

    WIDGET_EVENTS_NEARBY:           '/api/widget/events/nearby/',
    WIDGET_ACTIVITY:                '/api/widget/activity/',
    WIDGET_ATTENTION:               '/api/widget/attention/',
    getWidgetEventsNearby() {
        return this.getUrl(this.WIDGET_EVENTS_NEARBY);
    },
    getWidgetActivityUrl() {
        return this.getUrl(this.WIDGET_ACTIVITY);
    },
    getWidgetAttentionUrl() {
        return this.getUrl(this.WIDGET_ATTENTION);
    },

    PROJECT:                        '/api/{id_project}',
    PROJECT_QUOTE_UPLOAD:           '/api/{id_project}/quote/upload/{language}/',
    PROJECT_WORDCLOUD_UPLOAD:       '/api/{id_project}/wordcloud/upload/{language}/',
    PROJECT_DIGESTS:                '/api/{id_project}/digest/',
    PROJECT_DIGEST:                 '/api/{id_project}/digest/{id_digests}/',
    PROJECT_DIGEST_APPROVE_DECLINE: '/api/{id_project}/digest/{id_digests}/{action}/{role}/',
    PROJECT_DIGEST_COMMENTS:        '/api/{id_project}/comments/digests/{id_digests}/',
    PROJECT_DIGEST_HISTORY:         '/api/{id_project}/digest/{id_digests}/history/',
    PROJECT_DICTIONARY_SESSIONS:    '/api/{id_project}/dictionary/sessions/',
    PROJECT_DICTIONARY_SPEAKERS:    '/api/{id_project}/dictionary/speakers/',
    PROJECT_DICTIONARY_FONTS:       '/api/{id_project}/dictionary/fonts/',
    PROJECT_DICTIONARY_SESSIONS_TITLES: '/api/{id_project}/dictionary/sessions-titles/',

    getProjectUrl(options) {
        return this.getUrl(this.PROJECT, options);
    },
    getProjectQuoteUploadUrl(options) {
        return this.getUrl(this.PROJECT_QUOTE_UPLOAD, options);
    },
    getProjectWordcloudUploadUrl(options) {
        return this.getUrl(this.PROJECT_WORDCLOUD_UPLOAD, options);
    },
    getProjectDigestsUrl(options) {
        return this.getUrl(this.PROJECT_DIGESTS, options);
    },
    getProjectDigestUrl(options) {
        return this.getUrl(this.PROJECT_DIGEST, options);
    },
    getProjectDigestApproveDeclineUrl(options) {
        return this.getUrl(this.PROJECT_DIGEST_APPROVE_DECLINE, options);
    },
    getProjectDigestCommentsUrl(options) {
        return this.getUrl(this.PROJECT_DIGEST_COMMENTS, options);
    },
    getProjectDigestHistoryUrl(options) {
        return this.getUrl(this.PROJECT_DIGEST_HISTORY, options);
    },
    getProjectDictionarySessionsUrl(options) {
        return this.getUrl(this.PROJECT_DICTIONARY_SESSIONS, options);
    },
    getProjectDictionarySpeakersUrl(options) {
        return this.getUrl(this.PROJECT_DICTIONARY_SPEAKERS, options);
    },
    getProjectDictionaryFontsUrl(options) {
        return this.getUrl(this.PROJECT_DICTIONARY_FONTS, options);
    },
    getProjectDictionarySessionsTitlesUrl(options) {
        return this.getUrl(this.PROJECT_DICTIONARY_SESSIONS_TITLES, options)
    },

    WORDCLOUDS:                     '/api/{id_project}/wordcloud/',
    WORDCLOUD:                      '/api/{id_project}/wordcloud/{id_wordclouds}/',
    WORDCLOUD_WORD:                 '/api/{id_project}/wordcloud/{id_wordclouds}/{id_wordclouds_words}/',
    WORDCLOUD_COMMENTS:             '/api/{id_project}/comments/wordclouds/{id_wordclouds}/',
    WORDCLOUD_HISTORY:              '/api/{id_project}/wordcloud/{id_wordclouds}/history/',

    getWordCloudsUrl(options) {
        return this.getUrl(this.WORDCLOUDS, options);
    },
    getWordCloudUrl(options) {
        return this.getUrl(this.WORDCLOUD, options);
    },
    getWordCloudWordUrl(options) {
        return this.getUrl(this.WORDCLOUD_WORD, options);
    },
    getWordCloudComments(options) {
        return this.getUrl(this.WORDCLOUD_COMMENTS, options);
    },
    getWordCloudHistoryUrl(options) {
        return this.getUrl(this.WORDCLOUD_HISTORY, options);
    },

    QUOTES:                         '/api/{id_project}/quote/',
    QUOTE:                          '/api/{id_project}/quote/{id}/',
    QUOTE_SPEAKER_UPLOAD:           '/api/{id_project}/quote/speaker/{id_speaker}/upload/',
    QUOTE_COMMENTS:                 '/api/{id_project}/comments/quotes/{id}/',
    QUOTE_HISTORY:                  '/api/{id_project}/quote/{id}/history/',
    QUOTE_SVG:                      '/api/{id_project}/quote/{id}/svg/',
    QUOTE_APPROVE_DECLINE:          '/api/{id_project}/quote/{id}/{action}/{role}/',

    getQuotesUrl(options) {
        return this.getUrl(this.QUOTES, options);
    },
    getQuoteUrl(options) {
        return this.getUrl(this.QUOTE, options);
    },
    getQuoteSpeakerUploadUrl(options) {
        return this.getUrl(this.QUOTE_SPEAKER_UPLOAD, options);
    },
    getQuoteCommentsUrl(options) {
        return this.getUrl(this.QUOTE_COMMENTS, options);
    },
    getQuoteHistoryUrl(options) {
        return this.getUrl(this.QUOTE_HISTORY, options);
    },
    getQuoteSvgFullUrl(options) {
        return this.getFullUrl(this.QUOTE_SVG, options);
    },
    getQuoteApproveDeclineUrl(options) {
        return this.getUrl(this.QUOTE_APPROVE_DECLINE, options);
    },
    
    REPORTS:                      '/api/{id_project}/report/',
    REPORT:                       '/api/{id_project}/report/{id}/',
    REPORT_COMMENTS:              '/api/{id_project}/comments/reports/{id}/',
    REPORT_HISTORY:               '/api/{id_project}/report/{id}/history/',
    REPORT_SVG:                   '/api/{id_project}/report/{id}/svg/',
    REPORT_APPROVE_DECLINE:       '/api/{id_project}/report/{id}/{action}/{role}/',

    getReportsUrl(options) {
        return this.getUrl(this.REPORTS, options);
    },
    getReportUrl(options) {
        return this.getUrl(this.REPORT, options);
    },
    getReportApproveDeclineUrl(options) {
        return this.getUrl(this.REPORT_APPROVE_DECLINE, options);
    },
    getReportCommentsUrl(options) {
        return this.getUrl(this.REPORT_COMMENTS, options);
    },
    getReportHistoryUrl(options) {
        return this.getUrl(this.REPORT_HISTORY, options);
    },
    getReportSvgFullUrl(options) {
        return this.getFullUrl(this.REPORT_SVG, options);
    },

    SESSIONS:                       '/api/{id_project}/session/',
    SESSION:                        '/api/{id_project}/session/{id}/',
    SESSION_DOWNLOAD_SUMMARY:       '/api/{id_project}/session/{id}/download/summary/',
    SESSION_DOWNLOAD_TRANSCRIPTION: '/api/{id_project}/session/{id}/download/transcription/',
    SESSION_COMMENTS:               '/api/{id_project}/comments/sessions/{id}/',

    getSessionsUrl(options) {
        return this.getUrl(this.SESSIONS, options);
    },
    getSessionUrl(options) {
        return this.getUrl(this.SESSION, options);
    },
    getSessionDownloadSummaryFullUrl(options) {
        return this.getFullUrl(this.SESSION_DOWNLOAD_SUMMARY, options);
    },
    getSessionDownloadTranscriptionFullUrl(options) {
        return this.getFullUrl(this.SESSION_DOWNLOAD_TRANSCRIPTION, options);
    },
    getSessionCommentsUrl(options) {
        return this.getUrl(this.SESSION_COMMENTS, options);
    },

    SPEAKERS:                       '/api/speakers',
    SPEAKER:                        '/api/speakers/{id_speaker}/',
    getSpeakersUrl(options) {
        return this.getUrl(this.SPEAKERS, options);
    },
    getSpeakerUrl(options) {
        return this.getUrl(this.SPEAKER, options);
    },

    USERS:                          '/api/user/',
    USER:                           '/api/user/{id_users}/',
    USER_HISTORY:                   '/api/user/{id_users}/history/',
    USER_AUTH:                      '/api/user/auth/',
    USER_PROFILE:                   '/api/user/profile/',
    USER_LOGOUT:                    '/api/user/logout/',
    USER_ROLE:                      '/api/user/role/{slug}/',
    USER_FOR_PROJECT_ROLE:          '/api/user/project/role/{slug}/',

    getUsersUrl(options) {
        return this.getUrl(this.USERS, options);
    },
    getUserUrl(options) {
        return this.getUrl(this.USER, options);
    },
    getUserProfileUrl(options) {
        return this.getUrl(this.USER_PROFILE, options);
    },
    getUserHistoryUrl(options) {
        return this.getUrl(this.USER_HISTORY, options);
    },
    getUserAuthUrl(options) {
        return this.getUrl(this.USER_AUTH, options);
    },
    getUserLogoutUrl(options) {
        return this.getUrl(this.USER_LOGOUT, options);
    },
    getUsersForProjectRoleUrl(options) {
        return this.getUrl(this.USER_FOR_PROJECT_ROLE, options);
    },

    getUrl(template, options) {
        return (new URITemplate(template)).expand(options).toString();
    },

    ROLES:                          '/api/role/',

    getRolesUrl(options) {
        return this.getUrl(this.ROLES, options);
    },

    COMPANIES:                      '/api/company/',
    COMPANY:                        '/api/company/{id_company}/',

    getCompaniesUrl(options) {
        return this.getUrl(this.COMPANIES, options);
    },
    getCompanyUrl(options) {
        return this.getUrl(this.COMPANY, options);
    },

    SYNC_SPEAKERS:                  '/api/sync/speakers/',
    SYNC_SESSIONS:                  '/api/sync/sessions/',
    SYNC_EVENTS:                    '/api/sync/events/',

    getSyncSpeakersUrl(options) {
        return this.getUrl(this.SYNC_SPEAKERS, options);
    },
    getSyncSessionsUrl(options) {
        return this.getUrl(this.SYNC_SESSIONS, options);
    },
    getSyncEventsUrl(options) {
        return this.getUrl(this.SYNC_EVENTS, options);
    },

    getFullUrl(name, options, baseURL) {
        const template = this[name] || name;
        const base = (baseURL || this.BACKEND_URL);
        const url = this.getUrl(template, options);
        if(base.slice(-1) === '/' && url.slice(0, 1) === '/') {
            return base.slice(0, -1) + url;
        }
        return base + url;
    },

    getQueryString(options) {
        return (new URITemplate("{?q*}"))
            .expand({q:options})
            .toString();
    },
});
